// extracted by mini-css-extract-plugin
export default {"button":"index_button_GQuv0","app":"index_app_naU8g"};